function Model(params) {
  var self = this;
  self.product = params.result;
}

module.exports = Model;
